export const Types = {
    // SAVE_LIST_CATEGORY: 'SAVE_LIST_CATEGORY',
    SAVE_LIST_PROJECT: 'SAVE_LIST_PROJECT',
    SAVE_LIST_PROJECT_TAG: 'SAVE_LIST_PROJECT_TAG',
    SAVE_ALL_PROJECT_TAG: 'SAVE_ALL_PROJECT_TAG',
    // SAVE_LIST_POST_CATEGORY: 'SAVE_LIST_POST_CATEGORY'
}
